// --------------------------------------- Project List
import Project1img from '../Assets/project1.jpg';
import project2img from '../Assets/download.jpg' ;
import project3img from '../Assets/Rodan.jpg' ;
import getharvest from '../Assets/getharvest.jpg'

export const ProjectList = [
  {
    img: "https://user-images.githubusercontent.com/101576636/213684622-e839d7c3-d41c-4cd4-8014-737f6ca05dad.jpg",
    title: "JobSearching App",
    description: "A-Jobsearching-App with register, login, forgot password/reset password , apply job, post job and see applied jobs ,functionality.",
    tech_stack: "React,Material UI,NodeJs,MongoDB,Express",
    github_url: "https://github.com/Sukanta1304/A-Jobsearching-App",
    demo_url: "https://job-room-in.netlify.app/",
  }, 
  {
    img: getharvest,
    title: "Harvest Clone",
    description: "Harvest offers time tracking, invoicing, expense tracking, and time-based reporting. ",
    tech_stack: "React,Redux,Chakra UI,MongoDB,Express",
    github_url: "https://github.com/prabhatm39/GetHarvest-Clone",
    demo_url: "https://masai-getharvest-clone.netlify.app/",
  },  
  {
    img: "https://user-images.githubusercontent.com/97459069/187060501-df87fa20-d96f-451d-858d-d68d7f4f25b9.PNG",
    title: "Clockify Clone",
    description: "Free Time Tracker Clockify is the most popular free time tracker and timesheet app for teams of all sizes. Unlike all the other time trackers, Clockify lets you have an unlimited number of users for free.  ",
    tech_stack: "React,Redux,Chakra UI,MongoDB,Express",
    github_url: "https://github.com/hitesht4/legit-dust-8169",
    demo_url: "https://clockify-omega.vercel.app/",
  },
  {
    img: Project1img,
    title: "Zoom Car clone",
    description: "Try to make Zoom car (a car rental company) landing page with some functionality. It was a individual project, took around 4 days ",
    tech_stack: "Html,Css, Javascript,React,Chakra UI",
    github_url: "https://github.com/Sukanta1304/marvelous-flight-2061",
    demo_url: "https://wonderful-bombolone-01e61e.netlify.app/",
  },
  {
    img: project2img,
    title: "KFC clone",
    description:
      "A food supply chain app, build and maintained total userflow . It was a group project , we were total  6 members and it took around 5 days. ",
    tech_stack: "Html, Css, Javascript, ReactJS",
    github_url: "https://github.com/CYNO28/kfc",
    demo_url: "https://rococo-sunburst-64227a.netlify.app/",
  },
  {
    img: project3img,
    title: "Rodan+Fields clone",
    description: "A american beauty product selling company . It was my first group project and we were 6 members . it took around 5 days.",
    tech_stack: "HTML, CSS, Javascript, Bootstrap",
    github_url: "https://github.com/Sukanta1304/Rodan-Field-Clone-2",
    demo_url: "https://cool-khapse-fa2715.netlify.app/",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://user-images.githubusercontent.com/101576636/214081335-15bf1fb1-5a49-4271-a7ac-b029d4eb6fd7.png",
    name: "HTML",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081363-5cdb9960-c219-4a85-ab7f-eeb1d307dc83.png",
    name: "CSS",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081413-d8308b44-1208-4c8d-871c-1c69d65ecc88.png",
    name: "JavaScript",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081448-d60e670d-53da-4d1b-8384-5da8621fd038.png",
    name: "ReactJS",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081469-bc53a538-1409-4dc5-b99e-2d985554383d.png",
    name: "Redux",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081495-31be0187-9419-4718-b0d7-25d8675a1768.png",
    name: "NodeJS",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081532-aefa778e-6964-4986-88ac-66965a66c9a9.png",
    name: "ExpressJs",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214083607-42d1c1c8-5289-4896-9759-376b90f3f21e.png",
    name: "MongoDB",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081659-fd29ee24-003e-446b-8c57-eda7c7c70318.png",
    name: "Chakra UI",
  },
  {
    img: "https://user-images.githubusercontent.com/101576636/214081699-93dc2aec-0697-4c2b-81a1-c4df8aa86055.png",
    name: "Material UI",
  },
];
